/**
 * Lancer une événement de ronde
 * @type {string}
 */
export const SERVICE_POST_ROUND_EVENT = 'postRoundEvent'

/**
 * Validation d'un point de contrôle
 * @type {string}
 */
export const SERVICE_CHECKPOINT_VALIDATE = 'checkpointValidate'
